import "core-js/modules/es.array.push.js";
import draggable from 'vuedraggable';
import { S3_REGION } from '@/assets/js/utils.js';
import { mapState } from 'vuex';
export default {
  props: {
    drawerInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    draggable
  },
  computed: {
    ...mapState({
      State: state => state
    })
  },
  created() {
    this.State.selectUploadImage = [];
    this.getUploadImage();
  },
  data() {
    return {
      uploadFile: null,
      uploadFileInfo: null,
      uploadParams: null,
      uploadImageArray: [],
      getUploadParams: {
        pageIndex: 1,
        pageSize: 20,
        nameLike: '',
        isDirectory: false,
        region: S3_REGION,
        service: 'pp',
        type: 1,
        directoryName: '/Partyline/gallery/image'
      },
      uploading: false,
      uploadObj: {},
      visible: false,
      uploadImagePercent: {},
      uploadImageWidthHeight: {}
    };
  },
  methods: {
    getUploadImage() {
      this.getUploadParams.directoryName = '/Partyline/gallery/image';
      this.axios.post('/file/query-user-files', this.getUploadParams, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const list = res.data.result.records;
          this.uploadImageArray = list;
        }
      });
    },
    handleChange(file) {
      this.uploadFile = file;
    },
    judgeAllowUpload(file) {
      const isAllowUpload = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isAllowUpload) {
        this.$message.warning('Operation failed, the current picture is not jpeg or png.');
      } else {
        this.uploadFileInfo = file;
      }
      return isAllowUpload;
    },
    imageClass(item) {
      var _this$uploadImageWidt, _this$uploadImageWidt2;
      let className = '';
      const {
        width,
        height
      } = item;
      // 有时列表里面因为解析还没有宽高，所以多加一步从 upload 中获取的宽高
      const uploadImageWidth = (_this$uploadImageWidt = this.uploadImageWidthHeight[item.name]) === null || _this$uploadImageWidt === void 0 ? void 0 : _this$uploadImageWidt.width;
      const uploadImageHeight = (_this$uploadImageWidt2 = this.uploadImageWidthHeight[item.name]) === null || _this$uploadImageWidt2 === void 0 ? void 0 : _this$uploadImageWidt2.height;
      if (width && height || uploadImageWidth && uploadImageHeight) {
        const containerAspect = 16 / 9;
        const imgAspect = width / height;
        imgAspect >= containerAspect ? className = 'imageCover' : className = 'imageContain';
      }
      return className;
    },
    hideDeletePopover(id) {
      if (this.$refs[`deletePopper_${id}`] && this.$refs[`deletePopper_${id}`][0]) {
        this.$refs[`deletePopper_${id}`][0].showPopper = false;
      }
    },
    deleteUpload(item) {
      const currentImageId = item.id;
      const isUsing = Object.values(this.State.imagePositionInfo).some(info => info.imageId === currentImageId);
      if (isUsing) {
        this.$message.warning(this.$t('kioskHost.cannotDelete'));
        return;
      }
      const params = {
        id: item.id
      };
      this.axios.post('/file/delete', params, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.uploadImageArray.forEach((val, index) => {
            if (val.id == item.id) {
              this.uploadImageArray.splice(index, 1);
            }
          });
          this.$message.success(this.$t('kioskHost.deleteSuccess'));
        }
      });
    },
    changeImageArray() {},
    dragEnd() {},
    selectPicture(item) {
      if (this.drawerInfo.slotIndex < 0) return;
      if (this.State.selectUploadImage.includes(item.id)) {
        this.State.selectUploadImage = this.State.selectUploadImage.filter(id => id != item.id);
        this.controlSetImage('delete', item);
      } else {
        this.State.selectUploadImage = [];
        this.State.selectUploadImage.push(item.id);
        this.controlSetImage('set', item);
      }
    },
    controlSetImage(key, item) {
      var _this$userInfo$realPa, _this$uploadImageWidt3, _this$uploadImageWidt4;
      const isDelete = key === 'delete';
      const params = {
        joinCode: this.userInfo.joinCode,
        realPartyCode: (_this$userInfo$realPa = this.userInfo.realPartyList) === null || _this$userInfo$realPa === void 0 ? void 0 : _this$userInfo$realPa[0].realPartyCode,
        slotNumber: this.drawerInfo.slotIndex,
        imageUrl: isDelete ? null : item.url,
        imageId: isDelete ? null : item.id,
        imageName: isDelete ? null : item.name,
        imageWidth: isDelete ? null : item.width || ((_this$uploadImageWidt3 = this.uploadImageWidthHeight[item.name]) === null || _this$uploadImageWidt3 === void 0 ? void 0 : _this$uploadImageWidt3.width),
        imageHeight: isDelete ? null : item.height || ((_this$uploadImageWidt4 = this.uploadImageWidthHeight[item.name]) === null || _this$uploadImageWidt4 === void 0 ? void 0 : _this$uploadImageWidt4.height)
      };
      const url = isDelete ? '/partyline-backend/group/noLogin/delSlotImage' : '/partyline-backend/group/noLogin/updateSlotImage';
      this.axios.post(url, params).then(res => {
        if (res.data.errorCode === '0x0') {
          var _this$userInfo$realPa2;
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
          this.$emit('callback', {
            key: 'getUploadList',
            partyCode: (_this$userInfo$realPa2 = this.userInfo.realPartyList) === null || _this$userInfo$realPa2 === void 0 ? void 0 : _this$userInfo$realPa2[0].realPartyCode
          });
        }
      });
    },
    showActive(item) {
      return this.State.selectUploadImage.includes(item.id) ? 'active' : '';
    },
    uploadFileBySDK() {
      this.uploading = true;
      const params = {
        region: S3_REGION,
        service: 'pp',
        directoryName: '/Partyline/gallery/image',
        fileName: this.uploadFile.name
      };
      this.axios.post('/file/request-upload-for-sdk', params, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.uploadParams = result;
          AWS.config.region = result.identityPoolRegion;
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: result.identityPoolId
          });
          this.uploadImageArray.unshift({
            ...this.uploadParams,
            id: this.uploadParams.bucketId
          });
          this.getImageWidthHeight(this.uploadFileInfo, this.uploadParams.fileName);
          this.doUploadFile(this.uploadParams, this.uploadFile);
        } else {
          this.uploading = false;
        }
      });
    },
    doUploadFile(uploadParams, file) {
      const uploadObj = new AWS.S3.ManagedUpload({
        params: {
          Bucket: uploadParams.bucket,
          Key: uploadParams.objectKey,
          Body: file.raw,
          ACL: 'public-read'
        },
        service: new AWS.S3({
          region: uploadParams.region
        })
      });
      uploadObj.on('httpUploadProgress', progress => {
        const percent = Math.round(progress.loaded / progress.total * 100);
        this.$set(this.uploadImagePercent, this.uploadParams.fileName, percent);
      });
      uploadObj.promise().then(() => {
        this.addFile(uploadParams);
      });
    },
    addFile(uploadParams) {
      const params = {
        bucketId: uploadParams.bucketId,
        directoryId: uploadParams.directoryId,
        objectKey: uploadParams.objectKey
      };
      this.axios.post('/file/add-file', params, {
        requestBase: 'GATEWAY'
      }).then(res => {
        this.uploading = false;
        if (res.data.errorCode === '0x0') {
          this.getUploadImage();
        }
      });
    },
    getImageWidthHeight(file, fileName) {
      const url = window.URL || window.webkitURL;
      const image = new Image();
      image.onload = () => {
        this.$set(this.uploadImageWidthHeight, fileName, {
          width: image.width,
          height: image.height
        });
      };
      image.src = url.createObjectURL(file);
    }
  }
};